import { render, staticRenderFns } from "./imChat.vue?vue&type=template&id=4a78bf4e&scoped=true&"
import script from "./imChat.vue?vue&type=script&lang=js&"
export * from "./imChat.vue?vue&type=script&lang=js&"
import style0 from "./imChat.vue?vue&type=style&index=0&id=4a78bf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a78bf4e",
  null
  
)

export default component.exports